<template>
  <div class="tip-video">
    <tag-search
      :disabled="!this.tagPermission"
      ref="tagModal1"
      v-if="currentUserTags.length === 0"
      @itemClick="selectTag"
      trigger="click"
      :tags="tags"
      :current="video"
    >
      <div class="empty">
        <div class="tag-add-btn" @click="validatePermission"></div>
        <div class="tag-msg" @click="validatePermission">Tap to tag people</div>
      </div>
    </tag-search>
    <div v-if="currentUserTags.length > 0" class="not-empty">
      <tag-search
        :disabled="!this.tagPermission"
        ref="tagModal2"
        v-model="showAddModal"
        v-if="!hasMoreTag"
        @itemClick="selectTag"
        trigger="click"
        :tags="tags"
        :current="video"
      >
        <div class="add-container" @click="validatePermission">
          <div class="add-icon"></div>
          <div class="add-text">Tag Another Person</div>
        </div>
      </tag-search>
      <div class="more-tag-container" v-show="hasMoreTag">
        {{ `Only ${maxTagNum} people can be tagged in a post` }}
      </div>
      <div class="list-container">
        <div class="tag-item" v-for="tag in currentUserTags" :key="tag.user_id">
          <div
            class="person-image"
            v-lazy:background-image="{
              src: tag.profile_pic_url,
              error: emptyTagImg,
            }"
            :key="tag.profile_pic_url"
          ></div>
          <div class="person-main-container">
            <div class="person-main-container">
              <div class="username-container">
                <div class="username">{{ tag.username }}</div>
                <div class="approve-icon" v-show="tag.isVerified"></div>
              </div>
              <div class="des">{{ tag.full_name }}</div>
            </div>
          </div>
          <div class="del-btn" @click="removeTag(tag)"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "../../../../assets/style/theme";

.tip-video {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .tag-add-btn {
      background-image: url("../../../../../public/images/schedule_posts/Add_Detail@3x.png");
      width: 56px;
      height: 56px;
      background-size: cover;
      cursor: pointer;
      position: relative;

      .tag-container {
        position: absolute;
        top: 40px;
        right: -170px;
      }
    }

    .tag-msg {
      margin-top: 12px;
      font-size: 16px;
    }
  }

  .not-empty {
    width: 374px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .add-container {
      height: 44px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      border-bottom: solid 1px #e6e6e6;
      position: relative;

      &:hover,
      &:active {
        .add-text,
        .add-icon {
          opacity: 0.7;
          cursor: pointer;
        }
      }

      .add-text {
        color: @theme-color;
        font-size: 14px;
        margin-left: 10px;
      }

      .add-icon {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-image: url("../../../../../public/images/common/add_ins.png");
      }

      .tag-container {
        position: absolute;
        top: 40px;
        left: 10px;
      }
    }

    .more-tag-container {
      font-size: 14px;
      color: @font-color-gray;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: solid 1px #e6e6e6;
    }

    .list-container {
      flex: 1;
      overflow: auto;

      .tag-item {
        display: flex;
        align-items: center;
        padding: 7px 15px;

        &:hover {
          background-color: rgba(230, 43, 85, 0.1);
        }

        .person-image {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background-size: contain;
        }

        .person-main-container {
          margin-left: 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          overflow: hidden;

          .username-container {
            display: flex;
            align-items: center;

            .username {
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .approve-icon {
              background-image: url("../../../../../public/images/schedule_posts/tag_people/approve@3x.png");
              width: 12px;
              height: 12px;
              background-size: contain;
              margin-left: 4px;
              position: relative;
            }
          }

          .des {
            font-size: 12px;
            color: @font-color-gray;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .del-btn {
          width: 12px;
          height: 12px;
          background-image: url("../../../../../public/images/setting/tagpeople_close_b@3x.png");
          margin-left: 10px;
          background-size: contain;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<script>
import TagSearch from "../../../common/tag/Search";
import { mapGetters } from "vuex";
import { permissionValidate } from "../../../../service/publisher";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
import emptyTagImg from "../../../../../public/images/schedule_posts/tag_people/avatar_placeholder.png";

export default {
  name: "VideoTagPeopleComponent",
  components: { TagSearch },
  props: {
    video: {
      type: Object,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showAddModal: false,
      emptyTagImg, // tag people无头像时显示
    };
  },
  methods: {
    /**
     * 添加的tag
     */
    selectTag(item) {
      // 如果存在相同项点击无效
      const canAdd =
        this.video.usertags.findIndex((u) => u.user_id === item.user_id) === -1;
      if (canAdd) {
        item.position = [0.5, 0.5];
        this.video.usertags.push(item);
      }
      // 所有tag 弹出层都关闭
      if (this.$refs.tagModal1) {
        this.$refs.tagModal1.close();
      }
      if (this.$refs.tagModal2) {
        this.$refs.tagModal2.close();
      }
    },
    async validatePermission() {
      if (!this.tagPermission) {
        await permissionValidate({ type: "full" });
      }
    },
    /**
     * 删除指定tag
     * @param item 对应tag
     */
    async removeTag(item) {
      await this.validatePermission();
      const delIndex = this.video.usertags.findIndex(
        (u) => u.user_id === item.user_id
      );
      this.video.usertags.splice(delIndex, 1);
    },
  },
  computed: {
    ...mapGetters({
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    /**
     * 最大可以选中tag数量
     */
    maxTagNum() {
      let maxTagNum = 15;
      // 多图支持15个 单图支持20个
      if (this.$parent.$parent.images.length === 1) {
        maxTagNum = 20;
      } else {
        maxTagNum = 15;
      }
      return maxTagNum;
    },
    /**
     * 添加数量是否达到上限 单图20个多图15
     */
    hasMoreTag() {
      // 判断是否可能user tag 已经达到上限
      return this.tags.length >= this.maxTagNum;
    },
    /**
     * 是否拥有tag权限
     * @returns {*}
     */
    tagPermission() {
      return this.publisher.permissions.timeline_video_usertags;
    },
    /**
     * 当前选中tags
     * @returns {*|Array}
     */
    currentUserTags() {
      return this.video.usertags;
    },
  },
};
</script>
